export default __webpack_public_path__ + "static/media/cerealsImg.e79da81b.png";